"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.servicePlugins = void 0;
const SendFormPlugin_1 = require("./send-form/SendFormPlugin");
const ClearFieldsPlugin_1 = require("./ClearFieldsPlugin");
const CreateSubTasksPlugin_1 = require("./CreateSubTasksPlugin");
const PublishEventPlugin_1 = require("./PublishEventPlugin");
const RemoveSubTasksPlugin_1 = require("./RemoveSubTasksPlugin");
const SendEmailPlugin_1 = require("./SendEmailPlugin");
const UpdateRelatedEntityStatusPlugin_1 = require("./UpdateRelatedEntityStatusPlugin");
/**
 * Register service action plugins here
 */
exports.servicePlugins = [
    CreateSubTasksPlugin_1.CreateSubTasksPlugin,
    RemoveSubTasksPlugin_1.RemoveSubTasksPlugin,
    PublishEventPlugin_1.PublishEventPlugin,
    SendFormPlugin_1.SendFormPlugin,
    ClearFieldsPlugin_1.ClearFieldsPlugin,
    SendEmailPlugin_1.SendEmailPlugin,
    UpdateRelatedEntityStatusPlugin_1.UpdateRelatedEntityStatusPlugin
];
exports.default = exports.servicePlugins;
//# sourceMappingURL=default.js.map